<template>
	<div class="body">
		<div class="container">
			<el-row class="panel-group">
				<el-col :span="24">
					<div class="grid-content grid-content-left">
						<h4>数据概况</h4>
					</div>
					<div class="grid-content-right" v-if="institutionList&&institutionList.length">
						<el-select v-model="institutionId" style="width:100%" filterable placeholder="请选择机构" @change="institutionChange" :clearable="true">
							<el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="grid-content-right" v-if="teamList&&teamList.length">
						<el-select v-model="teamId" style="width: 100%;" placeholder="请选择团队" @change="institutionChange" :clearable="true">
							<el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</el-col>
				<div class="card">
					<el-col :xs="12" :sm="12" :lg="6" class="">
						<div :class="['card-panel',{'card-panel-cursor':user_institutionId>1}]" @click="goUrl('/front/alarmLog')">
							<div class="card-panel-text">报警</div>
							<div class="card-panel-icon-wrapper icon-alarm"></div>
							<div class="card-panel-description">
								<count-to :start-val="0" :end-val="homeData.alarmCount" :duration="2000" class="card-panel-num" />
							</div>
						</div>
					</el-col>
					<el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
						<div :class="['card-panel',{'card-panel-cursor':user_institutionId>1}]" @click="goUrl('/front/maintenanceOrder')">
							<div class="card-panel-text">维护工单</div>
							<div class="card-panel-icon-wrapper icon-maintenance"></div>
							<div class="card-panel-description">
								<count-to :start-val="0" :end-val="homeData.maintenanceCount" :duration="2000" class="card-panel-num" />
							</div>
						</div>
					</el-col>
					<el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
						<div :class="['card-panel',{'card-panel-cursor':user_institutionId>1}]" @click="goUrl('/front/maintenanceHelpOrder')">
							<div class="card-panel-text">求助工单</div>
							<div class="card-panel-icon-wrapper icon-help"></div>
							<div class="card-panel-description">
								<count-to :start-val="0" :end-val="homeData.maintenanceHelpCount" :duration="2000" class="card-panel-num" />
							</div>
						</div>
					</el-col>
					<el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
						<div :class="['card-panel',{'card-panel-cursor':user_institutionId>1}]" @click="goUrl('/message')">
							<div class="card-panel-text">平台消息</div>
							<div class="card-panel-icon-wrapper icon-analysis"></div>
							<div class="card-panel-description">
								<count-to :start-val="0" :end-val="messageCount" :duration="2000" class="card-panel-num" />
							</div>
						</div>
					</el-col>
				</div>
			</el-row>
			<el-row>
				<el-col :span="14">
					<div class="grid-content">
						<h4>设备分布</h4>
					</div>
					<div class="map-container">
						<div ref="chart" style="width: 100%; height: 100%"></div>
					</div>
				</el-col>
				<el-col :span="10">
					<div class="grid-content">
						<h4>设备分布详情</h4>
					</div>
					<el-table v-loading="loading" :data="datas" style="width: 100%" ref="multipleTable">
						<el-table-column prop="id" label="序号" width="60">
							<template slot-scope="scope">
								{{scope.$index |fromatIndex}}
							</template>
						</el-table-column>
						<el-table-column prop="provinceName" label="所在省份"></el-table-column>
						<el-table-column prop="cityName" label="所在市(区)"></el-table-column>
						<el-table-column prop="count" label="设备数量"></el-table-column>
					</el-table>
				</el-col>
			</el-row>
		</div>
		
		<el-dialog title="查看消息" :visible.sync="dialogMessageVisible" width="1000px" :close-on-click-modal="false">
			<div style="max-height: 550px;overflow-y: auto;" >
				<el-card class="box-card" v-for="(message,index) in messageList" :key="index"  style="margin-bottom:15px;">
				  <div slot="header" class="clearfix">
					<span>{{message.title}}</span>
					<span style="float: right; padding: 3px 0" type="text">{{message.createTime}}</span>
				  </div>
					<div v-html="message.message"></div>
				</el-card>
			</div>
			<div slot="footer" class="dialog-footer" style="text-align: center;">
				<el-button size="small" type="primary" style="display: inline-block;" @click="readMessage">我已知晓</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import CountTo from 'vue-count-to';
	import eventBus from '@/components/libs/eventBus.js';
	import store from '@/store/index.js'; //需要引入store
	import 'echarts/extension/bmap/bmap';
	import * as echarts from 'echarts';
	import common from '@/common/common.js';

	export default {
		components: {
			CountTo
		},
		data() {
			return {
				dialogMessageVisible:false,
				messageList: [],
				messageCount: 0,
				institutionList: [],
				teamList: [],
				institutionId: null,
				teamId: null,
				user_institutionId: 0,
				user_roleId: 0,
				loading: false,
				datas: [],
				homeData: {
					alarmCount: 0,
					maintenanceCount: 0,
					maintenanceHelpCount: 0,
					analysisCount: 0
				},
				valueList: [],
				dateList: [],
				option: {},
				noticeList: [],
				dialogNoticeVisible: false,
				noticeData: null,
				noticeId: null,
				showClose: false,
				closeTime: 0,
				balance: {},
				mapOptions: {
					backgroundColor: 'transparent',
					title: {
						text: '设备分布统计',
						subtext: '合计：2345台设备',
						left: 'center'
					},
					tooltip: {
						trigger: 'item'
					},
					bmap: [{
						center: [104.1954, 35.8617],
						zoom: 4,
						roam: true,
						mapStyle: {
							styleJson: [{
									featureType: 'water',
									elementType: 'all',
									stylers: {
										color: '#d1d1d1'
									}
								},
								{
									featureType: 'land',
									elementType: 'all',
									stylers: {
										color: '#f3f3f3'
									}
								},
								{
									featureType: 'railway',
									elementType: 'all',
									stylers: {
										visibility: 'off'
									}
								},
								{
									featureType: 'highway',
									elementType: 'all',
									stylers: {
										color: '#fdfdfd'
									}
								},
								{
									featureType: 'highway',
									elementType: 'labels',
									stylers: {
										visibility: 'off'
									}
								},
								{
									featureType: 'arterial',
									elementType: 'geometry',
									stylers: {
										color: '#fefefe'
									}
								},
								{
									featureType: 'arterial',
									elementType: 'geometry.fill',
									stylers: {
										color: '#fefefe'
									}
								},
								{
									featureType: 'poi',
									elementType: 'all',
									stylers: {
										visibility: 'off'
									}
								},
								{
									featureType: 'green',
									elementType: 'all',
									stylers: {
										visibility: 'off'
									}
								},
								{
									featureType: 'subway',
									elementType: 'all',
									stylers: {
										visibility: 'off'
									}
								},
								{
									featureType: 'manmade',
									elementType: 'all',
									stylers: {
										color: '#d1d1d1'
									}
								},
								{
									featureType: 'local',
									elementType: 'all',
									stylers: {
										color: '#d1d1d1'
									}
								},
								{
									featureType: 'arterial',
									elementType: 'labels',
									stylers: {
										visibility: 'off'
									}
								},
								{
									featureType: 'boundary',
									elementType: 'all',
									stylers: {
										color: '#fefefe'
									}
								},
								{
									featureType: 'building',
									elementType: 'all',
									stylers: {
										color: '#d1d1d1'
									}
								},
								{
									featureType: 'label',
									elementType: 'labels.text.fill',
									stylers: {
										color: '#999999'
									}
								}
							]
						}
					}],
					series: [{
						name: '设备数',
						type: 'effectScatter',
						coordinateSystem: 'bmap',
						data: [],
						symbolSize: function(val) {
							return 8;
						},
						encode: {
							value: 2
						},
						label: {
							formatter: '{b}',
							position: 'right',
							show: false
						},
						rippleEffect: {
							brushType: 'stroke', // 仅用轮廓渲染效果
							scale: 3 // 增加动画的范围，避免点重叠的视觉效果
						},
						/* itemStyle: {
							shadowBlur: 10,
							color:'#91cc75c'
						}, */
						emphasis: {
							label: {
								show: true
							}
						}
					}]
				},
				chartOptions: {
					tooltip: {
						trigger: 'axis',
						position: function(pt) {
							return [pt[0], '10%'];
						},
						formatter: function(params) {
							let time = new Date(params[0].axisValue);
							let date = time.getFullYear() + '-' +
								(time.getMonth() + 1).toString().padStart(2, '0') + '-' +
								time.getDate().toString().padStart(2, '0') + ' ' +
								time.getHours().toString().padStart(2, '0') + ':' +
								time.getMinutes().toString().padStart(2, '0');
							let tooltipContent = date + '<br>';
							params.forEach(function(item) {
								tooltipContent += item.marker + item.seriesName + ': ' + item.value[1] + '<br>';
							});
							return tooltipContent;
						}
					},
					xAxis: {
						type: 'time', // X轴为时间类型
						boundaryGap: false,
						axisLabel: {
							formatter: function(value) {
								// 格式化 x 轴标签为 HH:mm
								let date = new Date(value);
								let hours = date.getHours().toString().padStart(2, '0');
								let minutes = date.getMinutes().toString().padStart(2, '0');
								return hours + ':' + minutes; // 返回小时:分钟格式
							}
						}
					},
					yAxis: {
						type: 'value',
						boundaryGap: [0, '100%']
					},
					series: [] // 使用动态生成的多个曲线数据
				}
			};
		},
		filters: {
			fromatIndex(index) {
				return index + 1
			}
		},
		methods: {
			institutionChange() {
				console.log(this.institutionId)
				this.getDevicemap();
				this.getStatistics();
				//this.getTimeStatistics()
				this.getDeviceStatistics();
				this.queryMessageList(1,0)

			},
			handleClick(p) {
				var homeData = JSON.parse(JSON.stringify(this.homeData.todayOrderNum));
				homeData.queryParams = {
					startTime: p.name,
					endTime: p.name,
					isPay: 1
				};
				this.goUrl(homeData);
			},
			goUrl(url) {
				if (this.user_institutionId <= 1) {
					return;
				}
				if (this.teamId) {
					var query = {
						teamId: this.teamId,
					};
					common.routerPush(this, url, query)
				} else {
					common.routerPush(this, url, {})
				}

			},
			getDeviceStatistics() {
				this.$http({
						method: 'POST',
						url: 'devices/queryStatistics',
						data: {
							currentPage: 1,
							pageSize: 10,
							institutionId: this.institutionId,
							teamId: this.teamId
						}
					})
					.then((res) => {
						this.datas = res.data.data;
					})
			},
			getStatistics() {
				let that = this;
				this.$http({
						method: 'POST',
						url: 'statistics',
						data: {
							institutionId: this.institutionId,
							teamId: this.teamId
						}
					})
					.then((res) => {
						this.homeData = res.data.data
					})
			},
			getDevicemap() {
				let that = this;
				this.$http({
						method: 'POST',
						url: 'statistics/deviceMap',
						data: {
							institutionId: this.institutionId,
							teamId: this.teamId
						}
					})
					.then((res) => {
						var chartDom = this.$refs.chart;
						var myChart = echarts.init(chartDom);
						this.mapOptions.title.subtext = "合计：" + res.data.data.count + "台设备"
						if (res.data.data.maps) {
							this.mapOptions.series[0].data = res.data.data.maps
						}
						myChart.setOption(this.mapOptions);
						setTimeout(function() {
							console.log("color", myChart.getOption().color);
							myChart.setOption({
								bmap: [{
									center: [104.1954, 35.8617], // 设置为中国的中心点
									zoom: 4, // 调整缩放级别
								}]
							});
						}, 100);
					})
			},
			getSeriesData(datas) {
				return datas.map(item => {
					return {
						name: item.title, // 曲线名称
						type: 'line', // 曲线类型
						smooth: true, // 平滑曲线
						areaStyle: {},
						data: item.list ? item.list.map(dataPoint => [parseInt(dataPoint.time), parseFloat(dataPoint.value)]) : [] // 格式化时间和值
					};
				});
			},
			getTimeStatistics() {
				this.$http({
					method: 'POST',
					url: 'hourStatistics',
					data: {
						institutionId: this.institutionId
					}
				}).then((res) => {
					if (res.data.data) {
						this.chartOptions.series = this.getSeriesData(res.data.data)
					} else {
						this.chartOptions.series = null
					}
					console.log(JSON.stringify(this.chartOptions))
					this.$nextTick(() => {
						var chartDom = this.$refs.hourChart;
						var myChart = echarts.init(chartDom);
						myChart.setOption(this.chartOptions);
						myChart.resize();
					});

				})
			},
			queryInstitutionList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'institution/query',
					data: {
						currentPage: 1,
						pageSize: 100,
					},
				}).then(function(res) {
					that.institutionList = res.data.data;
				})
			},
			queryTeamList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'team/query',
					data: {
						currentPage: 1,
						pageSize: 100,
						defaultSort: {
							order: 'desc',
							prop: 'id'
						}
					},
				}).then(function(res) {
					that.teamList = res.data.data;
				})
			},
			queryMessageList(currentPage, pageSize) {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'mngr/cm/message/query',
					data: {
						institutionId:this.institutionId,
						currentPage: currentPage,
						pageSize: pageSize,
						isRead: pageSize == 0 ? null : false
					},
				}).then((res) => {
					this.messageList = res.data.data;
					if(this.messageList&&!this.messageList[0].isRead){
						this.dialogMessageVisible=true
					}
					this.messageCount = res.data.page.totalNum
				})
			},
			readMessage(){
				this.$http({
					method: 'POST',
					url: 'mngr/cm/message/read',
					data: {
						ids: this.messageList.map(item => item.id)
					},
				}).then((res) => {
					this.dialogMessageVisible=false
				})
			}
		},
		mounted() {
			this.getDevicemap();
			this.getStatistics();
			//this.getTimeStatistics()
			this.getDeviceStatistics();
			this.queryMessageList(1,1);
			/* if(this.user_institutionId>1){
				this.queryMessageList(1,1000);
			} */
			this.user_institutionId = sessionStorage.getItem('_institutionId');
			this.user_roleId = sessionStorage.getItem('_roleId');
			if (this.user_institutionId == "1" || this.user_institutionId == "-2") {
				this.queryInstitutionList()
			} else if (this.user_roleId == 2) {
				this.queryTeamList()
			}
		}
	};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	/deep/ .el-card__header{
		background-color: #7FB5EE;
	}
	.body {
		background-color: #ffff;
		height: 100%;
		width: 100%;
	}

	.container {
		width: calc(100% - 40px);
		margin: 0px 20px;
		height: 100%;
	}


	.grid-content {
		border-radius: 4px;
		height: 48px;
		line-height: 48px;
		font-size: 20px;
		font-weight: 500;
	}

	.grid-content-left {
		float: left;
	}

	.grid-content-right {
		float: right;
		padding-top: 4px;
	}



	.panel-group {
		.card {
			border: 1px solid #cccccc;
			border-radius: 10px;
			display: flex;
			padding-top: 10px;
			padding-left: 15px;
		}

		.card-panel-cursor {
			cursor: pointer;
		}

		.card-panel {
			height: 98px;
			font-size: 12px;
			position: relative;
			overflow: hidden;


			.card-panel-text {
				line-height: 18px;
				font-size: 14px;
				margin-bottom: 12px;
				font-weight: 500;
				color: black;
			}

			.card-panel-icon-wrapper {
				float: left;
				width: 40px;
				height: 40px;
			}

			.icon-alarm {
				background: url(../../assets/img/alarm.png);
				background-size: 100% 100%;
			}

			.icon-maintenance {
				background: url(../../assets/img/maintenance.png);
				background-size: 100% 100%;
			}

			.icon-help {
				background: url(../../assets/img/maintenanceHelp.png);
				background-size: 100% 100%;
			}

			.icon-analysis {
				background: url(../../assets/img/analysis.png);
				background-size: 100% 100%;
			}

			.card-panel-description {
				float: left;
				font-weight: bold;
				width: 68px;
				margin-left: 20px;

				.card-panel-num {
					font-size: 40px;
					line-height: 40px;
				}
			}
		}
	}

	.user-group {
		text-align: center;

		.num {
			color: red;
			font-size: 30px;
		}

		.title {
			margin-top: 10px;
		}
	}

	.order_list .echarts {
		width: 100%;
		height: 400px;
	}

	.map-container {
		height: 500px;
		width: calc(100% - 40px);
		margin: 0px 20px;
	}

	/deep/ .el-table th {
		background-color: transparent !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/base/home.vue